export enum SwitchValue {
  ExtendSeats = 'seats',
  ExtendPeriod = 'period',
}

export enum NoExtendableProductsReason {
  TrialInProgress = 1,
  DisabledSubscription = 2,
}
